












import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SimplePaginationCmp extends Vue {
  /**
   * @description 前一页
   */
  private prev() {
    this.$emit("prev");
  }
  /**
   * @description 下一页
   */
  private next() {
    this.$emit("next");
  }
}
